// extracted by mini-css-extract-plugin
export default {"toc-container":"tableOfContents_toc-container__wYnod","tree-item":"tableOfContents_tree-item__Csh5E"};